<template>
	<div>
		<div v-if="requirements.min_length" class="form-text text-base text-gray-600 mb-0">
			<i :class="pw_checks.min_length ? 'fal fa-check text-green-500' : 'fal fa-long-arrow-right'"></i>
			{{ requirements.min_length }} characters minimum
		</div>
		<div v-if="requirements.mixed_case" class="form-text text-base text-gray-600 mb-0">
			<i :class="pw_checks.mixed_case ? 'fal fa-check text-green-500' : 'fal fa-long-arrow-right'"></i>
			Contains upper and lowercase letters
		</div>
		<div v-if="requirements.number" class="form-text text-base text-gray-600 mb-0">
			<i :class="pw_checks.number ? 'fal fa-check text-green-500' : 'fal fa-long-arrow-right'"></i>
			Contains a number
		</div>
		<div v-if="requirements.special_char" class="form-text text-base text-gray-600 mb-0">
			<i :class="pw_checks.special_char ? 'fal fa-check text-green-500' : 'fal fa-long-arrow-right'"></i>
			Contains a special character
		</div>
		<div v-if="requirements.pass_history" class="form-text text-base text-gray-600 mb-0">
			Cannot reuse {{ requirements.pass_history }} prior passwords (checks on save)
		</div>
	</div>
</template>

<script>
	export default {
		props: ['password', 'requirements'],	

		data() {
			return {
			    pw_checks: {
					min_length: this.requirements.min_length ? false : true,
					mixed_case: this.requirements.mixed_case ? false : true,
					number: 	this.requirements.number ? false : true,
					special_char: this.requirements.special_char ? false : true,
				}
			}
		},


		watch: {
			password() {
				if (this.password) {
					if (this.requirements.min_length) {
						this.password.length >= this.requirements.min_length ? this.pw_checks.min_length = true : this.pw_checks.min_length = false;
					}
					if (this.requirements.mixed_case) {
						this.pw_checks.mixed_case = /[a-z]/.test(this.password) && /[A-Z]/.test(this.password);
					}
					if (this.requirements.number) {
						this.pw_checks.number = /\d/.test(this.password);
					}
					if (this.requirements.special_char) {
						this.pw_checks.special_char = !/^[a-zA-Z0-9- ]*$/.test(this.password);
					}
				} else {
					//back to the defaults if empty
					this.pw_checks = {
						min_length: this.requirements.min_length ? false : true,
						mixed_case: this.requirements.mixed_case ? false : true,
						number: 	this.requirements.number ? false : true,
						special_char: this.requirements.special_char ? false : true,						
					}
				}
			},

			pw_checks: {
				deep: true,
				handler() {
					this.$emit('pw_checks_changed', this.pw_checks);
				}
			}
		}	
	}

</script>